import type { SxProps } from '@mui/material'
import { BarChart } from '@mui/x-charts/BarChart'
import { Box, Typography } from '@mui/material'
import GLOBAL from 'modules/global'
import { STATUS_COLORS, barChartSlotProps, chartSx } from './chartDefaults'

interface Props {
  data: { category: string; revenue: number }[]
}

const RevenueByStatusChart = ({ data }: Props) => {
  if (!data || data.length === 0) return null

  const total = data.reduce((s, i) => s + i.revenue, 0)

  const barSx = data.reduce<Record<string, SxProps>>((sx, d, i) => {
    sx[`& rect:nth-of-type(${i + 1})`] = { fill: STATUS_COLORS[d.category] || '#999' }
    return sx
  }, {})

  return (
    <Box>
      <Typography variant='caption' sx={{ color: '#8A94A6' }}>Total Revenue</Typography>
      <Typography variant='h6' sx={{ fontWeight: 700, color: '#002C5F', mb: 2 }}>
        Rp{GLOBAL.formatCurrency(total)}
      </Typography>
      <BarChart
        layout='horizontal'
        yAxis={[{ scaleType: 'band', data: data.map((d) => d.category) }]}
        series={[{
          data: data.map((d) => d.revenue),
          valueFormatter: (v) => `IDR ${(v ?? 0).toLocaleString('id-ID')}`
        }]}
        height={Math.max(200, data.length * 60)}
        slotProps={{ ...barChartSlotProps, legend: { hidden: true } }}
        sx={{ ...barSx, ...chartSx }}
        margin={{ left: 140 }}
      />
    </Box>
  )
}

export default RevenueByStatusChart
